var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlog7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 276,
    viewBox: "0 0 552 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 276,
    rx: 16,
    fill: "#180A3A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 212,
    y: 74,
    width: 128,
    height: 128,
    rx: 64,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292 127.333H297.333C298.041 127.333 298.719 127.614 299.219 128.114C299.719 128.614 300 129.293 300 130V162C300 162.707 299.719 163.385 299.219 163.885C298.719 164.386 298.041 164.667 297.333 164.667H254.667C253.959 164.667 253.281 164.386 252.781 163.885C252.281 163.385 252 162.707 252 162V130C252 129.293 252.281 128.614 252.781 128.114C253.281 127.614 253.959 127.333 254.667 127.333H260V124.667C260 120.423 261.686 116.353 264.686 113.353C267.687 110.352 271.757 108.667 276 108.667C280.243 108.667 284.313 110.352 287.314 113.353C290.314 116.353 292 120.423 292 124.667V127.333ZM273.333 147.952V154H278.667V147.952C279.683 147.365 280.478 146.459 280.927 145.374C281.376 144.289 281.455 143.087 281.151 141.953C280.848 140.819 280.178 139.817 279.247 139.102C278.315 138.387 277.174 138 276 138C274.826 138 273.685 138.387 272.753 139.102C271.822 139.817 271.152 140.819 270.849 141.953C270.545 143.087 270.624 144.289 271.073 145.374C271.522 146.459 272.317 147.365 273.333 147.952ZM286.667 127.333V124.667C286.667 121.838 285.543 119.124 283.542 117.124C281.542 115.124 278.829 114 276 114C273.171 114 270.458 115.124 268.458 117.124C266.457 119.124 265.333 121.838 265.333 124.667V127.333H286.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog7);
export default __webpack_public_path__ + "static/media/blog7.fa33e22dc8bddd390bab7138cf93ccac.svg";
export { ForwardRef as ReactComponent };